import React from 'react';
import Dialog from './dialog.jsx';
import PropTypes from 'prop-types';
import R from 'ramda';

export default class EditCollectionDialog extends React.Component {
    static displayName = 'EditCollectionDialog';

    static propTypes = {
        routeGoBack: PropTypes.func.isRequired,
        deleteCollection: PropTypes.func.isRequired,
        editCollection: PropTypes.func.isRequired,
        collection: PropTypes.any.isRequired,
        content: PropTypes.any.isRequired,
    };

    onClose = () => {
        this.props.routeGoBack();
    };

    onDelete() {
        const { collection, deleteCollection } = this.props;
        deleteCollection(collection);
        this.onClose();
    }

    onSave() {
        const { collection, content, editCollection } = this.props;
        const ids = collection.content.map(c => c.id);

        const transaction = content.reduce(
            (acc, content) => {
                const inCollection = R.contains(content.id, ids);
                const input = this['checkbox' + content.id];

                if (inCollection !== input.checked) {
                    if (inCollection) {
                        acc.remove.push(content);
                    } else {
                        acc.add.push(content);
                    }
                }
                return acc;
            },
            { add: [], remove: [] }
        );

        editCollection({ transaction, collection }).then(() => {
            this.onClose();
        });
    }

    inputRef = id => el => {
        this['checkbox' + id] = el;
    };

    renderContent() {
        const { collection, content } = this.props;
        const ids = collection.content.map(c => c.id);

        const transform = ({ id, title }) => {
            return (
                <li key={id}>
                    <input
                        ref={this.inputRef(id)}
                        type="checkbox"
                        id={'check-' + id}
                        defaultChecked={R.contains(id, ids)}
                        defaultValue={'c' + id}
                    />
                    <label htmlFor={'check-' + id}>{title}</label>
                </li>
            );
        };

        const tmp = R.compose(
            R.map(transform),
            R.sortBy(R.prop('title'))
        );

        return tmp(content);
    }
    render() {
        const { collection } = this.props;

        const buttons = [];
        buttons.push({
            label: 'Delete',
            onClick: this.onDelete.bind(this),
            className: 'delete',
        });
        buttons.push({
            label: 'Cancel',
            dismiss: true,
        });
        buttons.push({
            label: 'Save',
            onClick: this.onSave.bind(this),
            primary: true,
        });

        return (
            <Dialog
                buttons={buttons}
                closeButton
                onClose={this.onClose.bind(this)}
                title="Edit Collection"
            >
                <div className="modal-body">
                    <div data-view-name="ManageContentView" className="edit">
                        <p className="aural">
                            All fields are required unless otherwise noted.
                        </p>
                        <label htmlFor="_courseload126">Collection Title</label>
                        <input
                            name="collection_title"
                            defaultValue={collection.name}
                            className="input-collection-title"
                            required
                            type="text"
                            id="_courseload126"
                            aria-required="true"
                            disabled="disabled"
                        />
                        <br />
                        <fieldset className="group">
                            <legend>
                                Choose materials to add to this collection
                            </legend>
                            <fieldset aria-live="polite">
                                <legend>
                                    <span className="aural">
                                        Check at least one.
                                    </span>
                                </legend>
                                <div className="js-material-selections material-selections">
                                    <div data-view-name="CheckboxesView">
                                        <ul>{this.renderContent()}</ul>
                                    </div>
                                </div>
                            </fieldset>
                        </fieldset>
                    </div>
                </div>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/edit_collection_dialog.ui.jsx